const Pin = ({ top, left, bgcolor }) => {
  const style = {
    top: `${top}%`, // Convert to a string with '%'
    left: `${left}%`, // Convert to a string with '%'
  };
  return (
    <div className={`pin absolute z-50 mapPin`} style={style}>
      <div
        className={`w-1.5 h-1.5 rounded-full bg-${bgcolor} inline-block`}
      ></div>
    </div>
  );
};
export default Pin;
